import axios from 'axios';
import { constant } from '@app/utils/constant';
import Cookies from 'js-cookie';

export const getSetting = async (keys: any) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  const data = {
    "key": keys
  };
  try {
    const response = await axios.post(constant.API_BASEPATH + '/getsetting', data, { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
  }
};

export const updateSetting = async (data: any) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  try {
    const response = await axios.post(constant.API_BASEPATH + '/setting', data, { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
  }
};


